import Vue from 'vue';
import env from '@/config/env';
import RaygunPlugin from '@/plugins/raygun.plugin';

const { RAYGUN: apiKey } = env.keys;
Vue.use(RaygunPlugin, { apiKey });

